module.exports = __webpack_public_path__ + "img/paypal-integration.e5d8cba5.png";